import React from "react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

export default function SocialShare({ title, text, url, instagramUser }) {
  const shareUrl = encodeURIComponent(url);
  const shareText = encodeURIComponent(text || title);

  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${shareText}&url=${shareUrl}`;
  const instagramUrl = instagramUser
    ? `https://www.instagram.com/${instagramUser}/`
    : null;

  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <h3>Comparte el contenido en:</h3>
      {/* Facebook */}
      <a
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Compartir en Facebook"
      >
        <FaFacebook size={28} color="#1877F2" className="iconSS" />
      </a>

      {/* X (Twitter) */}
      <a
        href={twitterUrl}
        target="_blank"
        rel="noopener noreferrer"
        title="Compartir en X"
      >
        <FaTwitter size={28} color="#1DA1F2" className="iconSS" />
      </a>

      {/* Instagram (link a perfil) */}
      {instagramUrl && (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          title="Ver en Instagram"
        >
          <FaInstagram size={28} color="#E4405F" className="iconSS" />
        </a>
      )}
    </div>
  );
}